import { createSelector } from '@ngrx/store';

export const getContactTypesState = createSelector(
    (state: any) => state.contactTypes,
    (state: any) => state.get('list')
);

export const getCreateContactTypeState = createSelector(
    (state: any) => state.contactTypes, 
    (state: any) => state.get('createContactType')
);

export const getUpdateContactTypeState = createSelector(
    (state: any) => state.contactTypes,
    (state: any) => state.get('updateContactType')
);
